import { useQuery } from '@fv/client-core'
import type { Workflow } from '@fv/models'

import { shipperFetch } from '@/utils/shipperFetch'

export const carrierServiceTypesQueryKey = 'carrier-service-types'

export const fetchCarrierServiceTypes = async (
  scac: string,
  workflow?: Workflow,
): Promise<CarrierService[]> => {
  return shipperFetch<CarrierService[]>(
    `/carriers/${scac}/serviceTypes?workflow=${workflow}`,
  )
}

export const useCarrierServiceTypes = (
  scac?: string,
  workflow: Workflow = 'ltl',
) => {
  if (!scac) {
    scac = 'default'
  }
  return useQuery([carrierServiceTypesQueryKey, scac, workflow], () =>
    fetchCarrierServiceTypes(scac ?? 'default', workflow),
  )
}

export type CarrierService = {
  guaranteed?: boolean
  guaranteedByTime?: string
  id: string
  name: string
}
